import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";

export default function AdminNumbers() {
  const [nums, setNums] = useState([]);
  useEffect(() => { api.get("/admin/numbers").then((r) => setNums(r.data)).catch(() => {}); }, []);

  const Status = ({ s }) => {
    const map = {
      waiting: { l: "Bekliyor", c: "text-[hsl(38,92%,60%)] border-[hsl(38,92%,60%)]/40" },
      received: { l: "SMS Alındı", c: "text-[hsl(142,71%,55%)] border-[hsl(142,71%,55%)]/40" },
      cancelled: { l: "İptal", c: "text-white/40 border-white/20" },
      finished: { l: "Bitti", c: "text-white/60 border-white/20" },
    };
    const m = map[s] || map.waiting;
    return <span className={`border px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-bold ${m.c}`}>{m.l}</span>;
  };

  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">İzleme</div>
        <h1 className="font-display text-3xl font-black">Tüm Numaralar</h1>
      </div>

      <div className="border border-white/10 bg-[hsl(0,0%,7%)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-[0.2em] text-white/40 border-b border-white/10">
            <tr>
              <th className="text-left py-3 px-4 font-bold">Telefon</th>
              <th className="text-left px-4 font-bold">Ülke</th>
              <th className="text-left px-4 font-bold">Servis</th>
              <th className="text-right px-4 font-bold">Fiyat</th>
              <th className="text-left px-4 font-bold">SMS</th>
              <th className="text-left px-4 font-bold">Durum</th>
              <th className="text-left px-4 font-bold">Tarih</th>
            </tr>
          </thead>
          <tbody>
            {nums.length === 0 && (
              <tr><td colSpan={7} className="py-8 text-center text-white/40">Kayıt yok.</td></tr>
            )}
            {nums.map((n) => (
              <tr key={n.id} className="border-b border-white/5">
                <td className="py-3 px-4 font-mono">+{n.phone}</td>
                <td className="px-4 text-white/70">{n.country_name}</td>
                <td className="px-4 uppercase text-xs tracking-wider text-white/70">{n.service}</td>
                <td className="px-4 text-right font-mono">₺{Number(n.price).toFixed(2)}</td>
                <td className="px-4 font-mono text-[hsl(142,71%,55%)]">{n.sms_code || "—"}</td>
                <td className="px-4"><Status s={n.status} /></td>
                <td className="px-4 text-white/50 text-xs">{new Date(n.created_at).toLocaleString("tr-TR")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
